module.exports = __webpack_public_path__ + "static/img/Adult-Human-Torso-A01-X-Ray.837d6faf.jpg";